
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-instagram-anonymously",
      function () {
        return require("private-next-pages/view-instagram-anonymously/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-instagram-anonymously"])
      });
    }
  